<template>
  <aside :class="{ 'active': showFilter }">
    <div class="v-store__filters">
      <div class="v-store__filter-heading">
        <h2>Filter by</h2>
        <button class="button button--small button--secondary" @click="resetFilter()">Clear All</button>
      </div>
      <hr>
      <!-- <div class="v-store__filter-label"><div>Keyword</div></div> -->
      <div class="v-store__filter-group">
        <div>
          <form @submit.prevent="activeSearchTerm = searchTerm">
            <input type="text" class="input input--light input--small" placeholder="Search Here" v-model="searchTerm" @blur="activeSearchTerm = searchTerm">
            <br>
            <input type="submit" class="button button--small" value="Search">
          </form>
        </div>
      </div>
      <hr>
      <div class="v-store__filter-label"><div>Categories</div></div>
      <div class="v-store__filter-group">
        <div>
          <div v-for="cat in categories" class="v-store__filter-item" :key="cat.id">
            <div class="v-store__filter-item-row">
              <input :id="cat.slug" type="checkbox" :value="cat.slug" v-model="activeCategories"><label :for="cat.slug">{{ cat.name }}</label>
              <div class="spacer"></div>
              <i v-if="cat.children" :class="`fas ${cat.expanded ? 'fa-minus' : 'fa-plus'}`" @click="cat.expanded = !cat.expanded"></i>
            </div>
            <div v-if="(cat.children && cat.expanded)">
              <div v-for="child in cat.children" class="v-store__filter-item v-store__filter-item--child" :key="child.id">
                <div class="v-store__filter-item-row">
                  <input :id="child.slug" type="checkbox" :value="child.slug" v-model="activeCategories"><label :for="child.slug">{{ child.name }}</label>
                  <div class="spacer"></div>
                  <i v-if="child.children" :class="`fas ${child.expanded ? 'fa-minus' : 'fa-plus'}`" @click="child.expanded = !child.expanded"></i>                  
                </div>
                <div v-if="(child.children && child.expanded)">
                  <div v-for="_child in child.children" class="v-store__filter-item v-store__filter-item--child" :key="_child.id">
                    <div class="v-store__filter-item-row">
                      <input :id="_child.slug" type="checkbox" :value="_child.slug" v-model="activeCategories"><label :for="_child.slug">{{ _child.name }}</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr>
      <div class="v-store__filter-label pointer" @click="toggleTags"><div>Tags</div><div><i :class="`fas ${tagsHeight === 0 ? 'fa-plus' : 'fa-minus'}`"></i></div></div>
      <div class="v-store__filter-group" :style="`height: ${tagsHeight}px`">
        <div ref="tagsInner">
          <div v-for="tag in tags" class="v-store__filter-item" :key="tag.slug">
            <div class="v-store__filter-item-row">
              <input :id="tag.slug" type="checkbox" :value="tag.slug" v-model="activeTags"><label :for="tag.slug">{{ tag.name }}</label>
            </div>
          </div>
        </div>
      </div>
      <hr>
      <div class="v-store__filter-label v-store__filter-label--brand pointer" @click="toggleBrands"><div>Brands</div><div><i :class="`fas ${brandsHeight === 0 ? 'fa-plus' : 'fa-minus'}`"></i></div></div>
      <div class="v-store__filter-group" :style="`height: ${brandsHeight}px`">
        <div ref="brandsInner">
          <div v-for="brand in brands" class="v-store__filter-item v-store__filter-item--brand" :key="brand.name">
            <div class="v-store__filter-item-row">
              <input :id="brand.name" type="checkbox" :value="brand.value" :disabled="brand.disabled" v-model="activeBrands"><label :for="brand.name">{{ brand.name }}</label>
            </div>
          </div>
        </div>
      </div>
      <hr>
      <div class="v-store__filter-label"><div>Price</div></div>
      <div class="v-store__filter-group v-store__filter-group--range">
          <range-slider
            class="v-store__filter-range"
            v-model="priceRangeValue"
            :min="0"
            :max="1000"
            :step="10"
            :tooltips="false"
            @input="handleRangeInput"
          ></range-slider>
        <div class="flex space-between"><span>${{ priceRangeValue[0] }}</span><span>${{ priceRangeValue[1] === 1000 ? `${priceRangeValue[1]}+` : priceRangeValue[1] }}</span></div>
      </div>
      <hr>
      <div class="v-store__filter-label"><div>Display Options</div></div>
      <div class="v-store__filter-group">
        <div class="v-store__filter-item">
          <div class="v-store__filter-item-row">
            <input id="show-sku" type="checkbox" v-model="showSku"><label for="show-sku">Show Product SKU</label>
          </div>
        </div>
        <div class="v-store__filter-item">
          <div class="v-store__filter-item-row">
            <input id="show-sales-only" type="checkbox" v-model="showSalesOnly"><label for="show-sales-only">Show Sales Only</label>
          </div>
        </div>
        <div class="v-store__filter-item v-store__filter-item--select">
          <div class="v-store__filter-item-row">
            <select id="per-page" v-model="productsPerPage">
              <option value="15">15 Products Per Page</option>
              <option value="30">30 Products Per Page</option>
              <option value="60">60 Products Per Page</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  </aside>
</template>
<script>
import debounce from 'lodash/debounce'
import RangeSlider from '@vueform/slider'
export default {
  components: { RangeSlider },

  props: ['brands', 'categories', 'show-filter', 'tags'],

  data () {
    return {
      brandsHeight: 0,
      tagsHeight: 0,

      activeBrands: [],
      activeCategories: [],
      activePriceHigh: 1000,
      activePriceLow: 0,      
      activeSearchTerm: '',
      activeTags: [],

      priceRangeValue: [0, 1000],
      searchTerm: '',

      showSku: false,
      showSalesOnly: false,
      productsPerPage: 24,
    }
  },

  mounted () {
    this.$router.isReady().then(() => {
      if (this.$route.query.category) {
        this.activeCategories.push(this.$route.query.category)
        let activeCategory = window.categories.find(cat => {
          console.log(cat.slug, this.$route.query.category)
          return cat.slug === this.$route.query.category
        })
        if (activeCategory && activeCategory.parent_id !== 0) {
          this.categories.forEach(cat => {
            if (cat.id === activeCategory.parent_id) {
              cat.expanded = true
            }
          })
        }
        if (document.querySelector('[rel=canonical]')) document.querySelector('[rel=canonical]').href = 'https://novitatech.com.au/shop/?category=' + this.$route.query.category
      }

      if (this.$route.query['sales'] && this.$route.query['sales'] === 'true') {
        this.showSalesOnly = true
      }

      if (this.$route.query['sku'] && this.$route.query['sku'] === 'true') {
        this.showSku = true
      }

      if (this.$route.query['brands']) {
        this.activeBrands = this.$route.query['brands'].split(',')
      }

      if (this.$route.query['search']) {
        this.searchTerm = this.$route.query['search']
        this.activeSearchTerm = this.$route.query['search']
      }

      if (this.$route.query['product-tag']) {
        setTimeout(() => {
          this.toggleTags()
        }, 1000)
        this.activeTags.push(this.$route.query['product-tag'])
      }    
      this.emitFilterParameters()
    })
  },

  watch: {
    activeBrands () { this.emitFilterParameters() },
    activeBrands () { this.emitFilterParameters() },
    activeCategories () { this.emitFilterParameters() },
    activePriceHigh () { this.emitFilterParameters() },
    activePriceLow () { this.emitFilterParameters() },
    activeSearchTerm () { this.emitFilterParameters() },
    activeTags () { this.emitFilterParameters() },
    showSku () { this.emitDisplayParamerers() },
    showSalesOnly () { this.emitDisplayParamerers() },
    productsPerPage () { this.emitDisplayParamerers() }
  },

  methods: {
    emitDisplayParamerers () {
      this.$emit('display', {
        showSalesOnly: this.showSalesOnly,
        showSku: this.showSku,
        productsPerPage: this.productsPerPage,
      })
    },

    emitFilterParameters () {
      this.$emit('filter', {
        activeBrands: this.activeBrands,
        activeCategories: this.activeCategories,
        activePriceHigh: this.activePriceHigh,
        activePriceLow: this.activePriceLow,
        activeSearchTerm: this.activeSearchTerm,
        activeTags: this.activeTags,
      })
    },

    handleRangeInput: debounce(function () {
      setTimeout(() => {
        this.activePriceLow = this.priceRangeValue[0]
        this.activePriceHigh = this.priceRangeValue[1]
      })
    }, 500),

    resetFilter () {
      this.activeSearchTerm = ''
      this.activeBrands = []
      this.activeCategories = []
      this.activeTags = []
      this.activePriceHigh = 1000
      this.activePriceLow = 0
      document.activeElement.blur()
    },

    toggleTags () {
      if (this.tagsHeight === 0) {
        this.tagsHeight = this.$refs.tagsInner.offsetHeight + 20
      } else {
        this.tagsHeight = 0
      }
    },

    toggleBrands () {
      if (this.brandsHeight === 0) {
        this.brandsHeight = this.$refs.brandsInner.offsetHeight + 20
      } else {
        this.brandsHeight = 0
      }
    }    
  }
}
</script> 
<style src="@vueform/slider/themes/default.css"></style>
<style lang="scss">
@import '../../assets/scss/variables';

body {
  --slider-height: 3px;
  --slider-connect-bg: #ed185d;
  --slider-handle-bg: #ed185d;
}

.v-store {
  aside {
    background-color: #f4f4f4;
    overflow: hidden;
    padding: 0 30px 0 15px;
    position: sticky;
    // margin: 0 -15px;
    min-height: 0;
    height: 0;
    transition: height 0.6s, padding 0.6s;
    // width: 100%;
    top: 61px;
    z-index: 8999;


    @media (min-width: $lg) {
      height: auto;
      margin: 0;
      
      position: relative;
      width: 350px;
      flex-shrink: 0;
      // padding-right: 50px;
      // padding-top: 50px;   
      padding: 20px;     
      top: 0;  
    }

    &.active {
      overflow: scroll;
      padding: 30px 30px 0 15px;
      height: 100vh;
    }
  }

  &__filters {
    // position: sticky;
    color: $mpurple;
    // top: 30px;
    
    h2 {
      color: $mpurple;
      font-weight: bold;
      font-size: 18px;
      margin-bottom: 20px;
    }

    hr {
      border: 1px solid rgba(0, 0, 0, 0.05);
      margin-bottom: 20px;
    }
  }

  &__filter-heading {
    align-items: center;
    display: flex;
    justify-content: space-between;
    padding-bottom: 15px;

    h2 {
      margin: 0;
    }
  }

  &__filter-label {
    color: $mpurple;
    display: flex;
    font-size: 14px;
    font-weight: 600;
    justify-content: space-between;
    text-transform: uppercase;
  }

  &__filter-group {
    margin-bottom: 10px;
    overflow: hidden;
    padding-top: 10px;
    transition: height 0.3s ease-in-out;

    &--range {
      overflow: visible;
    }

    > div {
      // margin-top: 20px;
    }

    form {
      input[type="submit"] {
        width: 100%;
      }

      input[type="text"] {
        border-color: #e7e4e8;
        border-radius: 60px;
        background-color: #fff;

        ::placeholder {
          color: red;
        }
      }

      .button {
        margin-right: 10px;
      }
    }
  }

  &__filter-item {
    cursor: pointer;
    display: block;
    text-transform: capitalize;

    &--brand {
      text-transform: none;
    }

    &--child {
      padding-left: 30px;
    }

    &-row {
      display: flex;
      align-items: center;
    }

    &--select {
      padding: 14px 0 0;

      select {
        border: 2px solid $pink;
        border-radius: 3px;
        color: $purple;
        cursor: pointer;
        font-family: 'Raleway', Helvetica, sans-serif;
        font-size: 14px;
        padding: 2px;

        &:focus {
          border: 2px solid $pink;
          outline: none;
        }
      }
    }

  }

  &__filter-range {
    padding-left: 7px;
    padding-right: 7px;
    margin-bottom: 20px;
    margin-top: 20px;
  }  
}
</style>